/*-----------------------------------------------------------------
- Auth Fields
-----------------------------------------------------------------*/

export default {
    username     : 'نام کاربری',
    email        : 'ایمیل',
    mobile       : 'شماره همراه',
    code_melli   : 'کد‌ملی',
    password     : 'رمز‌ عبور',
    new_password : 'رمز‌ عبور جدید',
    new_password2: 'تکرار رمز ‌عبور جدید',

    // Used for single accepted value
    placeholder             : '{0} خود را وارد کنید.',
    placeholderJoinCharacter: ' یا ',
};
